import { render } from "./legoDashboardItem.vue?vue&type=template&id=7275c159"
import script from "./legoDashboardItem.vue?vue&type=script&lang=js"
export * from "./legoDashboardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoDashboard/legoDashboardItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7275c159"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7275c159', __exports__)) {
    api.reload('7275c159', __exports__)
  }
  
  module.hot.accept("./legoDashboardItem.vue?vue&type=template&id=7275c159", () => {
    api.rerender('7275c159', render)
  })

}


export default __exports__